module.exports = __webpack_public_path__ + "static/media/YapRiHao.84cb7e14.png";